/**
 * Manito Appointments — PrimeVue Theme Preset
 *
 * Customizes the Aura preset to match the app's brand colors:
 *   Primary (PrimeVue interactive): Teal #26A69A
 *   Surface: Slate palette (matches KTUI config.ktui.css)
 *
 * This keeps PrimeVue visually aligned with the KTUI/Tailwind
 * design tokens defined in assets/metronic/css/config.ktui.css.
 */
import { definePreset, palette } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const ManitoPreset = definePreset(Aura, {
  semantic: {
    // Teal primary for PrimeVue interactive elements
    primary: palette('#26A69A'),

    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
      dark: {
        primary: {
          color: '{primary.400}',
          contrastColor: '{surface.900}',
          hoverColor: '{primary.300}',
          activeColor: '{primary.200}',
        },
        surface: {
          0: '#ffffff',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          900: '{slate.900}',
          950: '{slate.950}',
        },
      },
    },
  },
})

export default ManitoPreset
